import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import esCo from 'element-plus/es/locale/lang/es'
import App from './App.vue'
import './assets/style.css' 
import 'element-plus/dist/index.css'
import router from './router';

createApp(App).use(router).use(ElementPlus, {
    locale: esCo,
  }).mount('#app');
